import React, { FunctionComponent } from "react"
import CKEditor from "ckeditor4-react"

interface iProps {
  value?: string
  onChange?: (data: string) => void
}

CKEditor.editorUrl = "/ckeditor/ckeditor.js"

const WysiwygInput: FunctionComponent<iProps> = ({ value = "", onChange }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (event: any) => {
    const data = event.editor.getData()
    onChange && onChange(data)
  }

  return <CKEditor data={value} onChange={handleChange} />
}

export default WysiwygInput
